module.exports = __webpack_public_path__ + "h5/img/test-icon-2.d81653a0.png";